$(function () {

    if ($('#contact').length) {

        if (window.helpers.getQueryVariable('source')) {
            let source = filterResult(decodeURIComponent(window.helpers.getQueryVariable('source')));

            setTimeout(function () {
                $('select').each(function (i, e) {

                    $(this).find('option').each(function (i2, e2) {

                        if (filterResult($(this).text()) === source) {
                            $(this).attr('selected', 'selected');
                        }
                    });

                });
            }, 500);
        }

        if (window.helpers.getQueryVariable('type')) {
            let type = filterResult(decodeURIComponent(window.helpers.getQueryVariable('type')));

            setTimeout(function () {
                $('select').each(function (i, e) {

                    $(this).find('option').each(function (i2, e2) {

                        if (filterResult($(this).text()) === type) {
                            $(this).attr('selected', 'selected');
                        }
                    });

                });
            }, 500);
        }

    }

});

function filterResult(result) {
    // result = result.replace(/%20/g, ' ');
    // remove ’ and ' from string
    result = result.replace(/’/g, '');
    result = result.replace(/'/g, '');
    return result;
}
